import Modal from 'react-modal';
import IdCardCreate from '../IdCardCreate';
import IdCardEdit from '../IdCardEdit';
import ProjectIdCardCreate from '../ProjectIdCardCreate';
import ProjectIdCardEdit from '../ProjectIdCardEdit';

import { Wrapper, CloseButton, ContentWrapper, ModalTitle } from './styles';

const EditIdCardModal = ({ onModalClose, isEditMode, isProjectCard, projectId }) => {
  let IdCardAlterComponent = null;
  if (isEditMode && isProjectCard) IdCardAlterComponent = ProjectIdCardEdit;
  if (isEditMode && !isProjectCard) IdCardAlterComponent = IdCardEdit;
  if (!isEditMode && isProjectCard) IdCardAlterComponent = ProjectIdCardCreate;
  if (!isEditMode && !isProjectCard) IdCardAlterComponent = IdCardCreate;

  return (
    <Modal
      isOpen={true}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc
      onRequestClose={onModalClose}
      style={{
        content: {
          left: '50%',
          transition: 'left 0.5s ease-out',
        },
      }}>
      <Wrapper>
        <ModalTitle>{isEditMode ? isProjectCard ? 'Edit project id card' : 'Edit module id card' : isProjectCard ? 'Create project id card' : 'Create module id card:'}</ModalTitle>
        <CloseButton onClick={() => onModalClose()} />
        <ContentWrapper>
          <IdCardAlterComponent onModalClose={onModalClose} projectId={projectId} />
        </ContentWrapper>
      </Wrapper>
    </Modal>
  );
};

export default EditIdCardModal;
